import React, { useState, useEffect } from "react";
import PearlImg from "../../assets/images/celebration-images/celeb_pearl.png";
import EmeraldImg from "../../assets/images/celebration-images/celeb_emerald.png";
import DiamondImg from "../../assets/images/celebration-images/celeb_diamond.png";
import FirstTrimesterImg from "../../assets/images/celebration-images/celeb_tri1_en.png";
import SecondTrimesterImg from "../../assets/images/celebration-images/celeb_tri2_en.png";
import FirstTrimesterImgES from "../../assets/images/celebration-images/celeb_tri1_es.png";
import SecondTrimesterImgES from "../../assets/images/celebration-images/celeb_tri2_es.png";
import Confetti from "react-confetti"; // For celebratory confetti bursts
// Brand colors for confetti
const confettiColors = ["#FFE9D9", "#4E7E6E", "#EAF0F0", "#BCD0BF"];

export const getCelebrationImage = (code: string, lang: string) => {
  if (code === "PearlUnblocked") {
    return PearlImg;
  } else if (code === "DiamondUnblocked") {
    return DiamondImg;
  } else if (code === "EmeraldUnblocked") {
    return EmeraldImg;
  } else if (code === "FirstTrimesterCompleted" && lang === "es") {
    return FirstTrimesterImgES;
  } else if (code === "SecondTrimesterCompleted" && lang === "es") {
    return SecondTrimesterImgES;
  } else if (code === "FirstTrimesterCompleted") {
    return FirstTrimesterImg;
  } else if (code === "SecondTrimesterCompleted") {
    return SecondTrimesterImg;
  }
};

export const ConfettiTimedMobile = () => {
  const [show, setShow] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => setShow(false), 6000);
    return () => clearTimeout(timer);
  }, []);
  return show ? (
    <div className="modal__confetti">
      <Confetti
        width={361}
        height={400}
        numberOfPieces={150}
        gravity={0.3}
        colors={confettiColors}
      />
    </div>
  ) : null;
};

export const ConfettiTimed = () => {
  const [show, setShow] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => setShow(false), 6000);
    return () => clearTimeout(timer);
  }, []);
  return show ? (
    <div className="modal__confetti">
      <Confetti
        width={570}
        height={580}
        numberOfPieces={150}
        gravity={0.3}
        colors={confettiColors}
      />
    </div>
  ) : null;
};
// -------------------------------------------------------------------------
// COMPONENT: AnimatedCounter
// Animates numbers from 0 to final value (e.g., +500 points)
// -------------------------------------------------------------------------

export const AnimatedCounter = (value: { value: number }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const end = value.value;
    if (start === end) return;

    const duration = 1500; // total time in ms
    const incrementTime = 15;
    const step = Math.ceil((end - start) / (duration / incrementTime));

    const counter = setInterval(() => {
      start += step;
      if (start >= end) {
        start = end;
        clearInterval(counter);
      }
      setCount(start);
    }, incrementTime);

    return () => clearInterval(counter);
  }, [value]);

  return <span>{count}</span>;
};
